import translate from '../core/tools/translate';
import CoreControl from './CoreControl';
import { VectorType } from './VectorType';
import filters from '../core/filters';
import _ from "lodash";
import environment from '../environment';
import api from '../api';
import WorkshopPartLayer from '../layers/WorkshopPartLayer';

export class WorkshopPartControl extends CoreControl {
    constructor() {
        super({ name: 'WorkshopPart' });

        this.select = this.select.bind(this);
        this.createFilter = this.createFilter.bind(this);
        this._filterCallback = this._filterCallback.bind(this);
        this._change = this.change.bind(this);
        this.resizeIcon = this.resizeIcon.bind(this);

        this._instance = null;
    }

    static getInstance() {
        if (!WorkshopPartControl._instance) {
            WorkshopPartControl._instance = new WorkshopPartControl();
        }

        return WorkshopPartControl._instance;
    }

    resizeIcon(value) {
        const { options } = this.getLayer();
        const { symbology } = options;
        const imgSize = {
            sm: '_sm',
            xs: '_xs'
        };

        const sizes = [
            { size: 'large', imgSuffix: '', iconSize: [50, 64], iconAnchor: [25, 60], labelAnchor: [25, -32] },
            { size: 'medium', imgSuffix: '', iconSize: [38, 48], iconAnchor: [19, 48], labelAnchor: [19, -24] },
            { size: 'small', imgSuffix: imgSize.xs, iconSize: [12, 12], iconAnchor: [6, 6], labelAnchor: [6, 0] },
        ];

        const { imgSuffix, iconSize, iconAnchor, labelAnchor, size } = sizes.find(x => x.size === value);
        api.general.log.action(environment._getContextEnum(this.options.name), `Mudou Tam. Icone: ${size}`);

        symbology.style.icon = {
            getUrl: data => {
                const applyUrl = imgSuffix === imgSize.sm || imgSuffix === imgSize.xs
                    ? WorkshopPartLayer.getPinIcon[`${data.LayerContext}${imgSuffix}`]
                    : WorkshopPartLayer.getPinIcon[data.LayerContext];

                return applyUrl;
            },
            iconSize,
            iconAnchor,
            labelAnchor
        };

        this.getLayer().setOptions({ symbology });
        if (this.check() && this.getLayer().visible()) {
            return this.getLayer().reload();
        }
    }

    init() {
        const values = {
            help: translate(`Help.${this.options.name}`),
            id: 'layer-workshop-part',
            input: 'checkbox',
            label: translate(`Common.${this.options.name}`),
            layer: this.getLayer,
            change: this._change,
            name: this.options.name,
            type: 'vector-points',
            resize: {
                name: `pinSize${this.options.name}`,
                change: this.resizeIcon,
                type: 'radio'
            },
            filter: {
                enable: true,
                click: this.createFilter
            }
        };

        if (!this._instance) {
            this._instance = new VectorType(values);
        }

        setTimeout(() => {
            this.getControls().radio[`pinSize${this.options.name}`].value = 'small';
        }, 500);
    }

    select(value) {
        this.getLayer().setOptions({
            remote: {
                params: {
                    id: value
                }
            }
        });

        if (this.check() && this.getLayer().visible()) {
            return this.getLayer().redraw();
        }
    }

    createFilter() {
        filters.create({
            id: `${_.kebabCase(this.options.name)}-filter-id`,
            label: translate(`Common.${this.options.name}`),
            type: 'workshopPart',
            onSubmit: this._filterCallback
        });
    }

    change(e) {
        if (e.checked) {
            this.createFilter();
        } else {
            filters.close();
        }

        super._change(e);
    }

    _filterCallback(filterData) {
        const { contexts } = filterData;
        const layer = this.getLayer();
        const { params } = layer.options.remote;

        params.idLayerContexts = Array.isArray(contexts.value)
            ? contexts.value
            : contexts.value ? [contexts.value] : null;

        layer.setOptions({
            remote: {
                params
            }
        });


        layer.redraw();
    }
}

export default WorkshopPartControl;



// WEBPACK FOOTER //
// ./src/scripts/controls/WorkshopPartControl.js